import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';

export const getReport = postData => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.ITEMSUMMARY_GETREPORT,
        types.ITEMSUMMARY_FETCHING,
        types.ITEMSUMMARY_FETCHERROR,
        `Reports/GetItemSummaryReport`,
        postData
      )
    );
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.ITEMSUMMARY_CLEARREPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/itemsummary/state/actions.js